import type { AlgoliaProductHit } from '~/types/algolia';
import { useProductListContext } from '~/utilities/context/static/ProductListContext';
import type { SectionNameType } from '~/utilities/vendors/dataLayer.type';

export const useProductImpressionSectionName = (hit: AlgoliaProductHit): SectionNameType => {
  const { isPLP } = useProductListContext();

  if (!isPLP) {
    return 'srp';
  }

  return hit.isRBP ? 'plp_RBP' : 'plp';
};
